import React, { useMemo } from "react";
import { Formik } from "formik";
import { Button, ErrorMessageField, SelectPickerInput } from "@shared/components";
import { SensorDataFile } from "@shared/models";

import { getInitValues, createValidationSchema } from "./formHelpers";

import "./index.scss";

interface CreateDotMarkerModalProps {
  files: SensorDataFile[];
  onClose: () => void;
  onSubmit: (value: number) => void;
}

const CreateDotMarkerModal = (props: CreateDotMarkerModalProps) => {
  const { onClose, onSubmit, files } = props;

  const initValues = useMemo(() => {
    return getInitValues();
  }, []);

  const filesOptions = useMemo(() => {
    return files.map((f) => ({ label: f.custom_name, value: f.id }));
  }, [files]);

  return (
    <div className="dot-modal modal-content-wrapper">
      <div className="modal-heading">Add New Dot</div>
      <Formik
        validationSchema={createValidationSchema}
        enableReinitialize={true}
        validateOnBlur={false}
        onSubmit={(values, { setSubmitting }) => {
          onSubmit(Number(values.file));
          setSubmitting(false);
        }}
        initialValues={initValues}
      >
        {({ handleSubmit, handleChange, setFieldValue, values }) => (
          <>
            <form onSubmit={handleSubmit}>
              <div className="modal-content">
                <div className="form-description">
                  As the value for this dot is the same for both lines, please choose the dot from which file you want
                  to add
                </div>
                <div className="form-rows">
                  <div className="files-column">
                    <SelectPickerInput
                      searchable={false}
                      name="file"
                      data={filesOptions}
                      onChange={(value) => setFieldValue("file", value)}
                      onClean={handleChange}
                      labelTitle="File*"
                      value={values.file}
                      placeholder="File"
                    />
                    <ErrorMessageField name="file" />
                  </div>
                </div>
              </div>
              <div className="modal-actions">
                <Button appearance="subtle" className="subtle auto-width" onClick={() => onClose()}>
                  Cancel
                </Button>
                <Button type="submit" className="blue auto-width">
                  Create
                </Button>
              </div>
            </form>
          </>
        )}
      </Formik>
    </div>
  );
};

export default CreateDotMarkerModal;
